import React from 'react';
import Select from 'react-select';

type TSelect = {
    containerClassName: string;
    error: string;
    errorClassName: string;
    name: string;
    className: string;
    placeholder: string;
    value: any;
    clearable: boolean;
    onChange: (e: any) => void;
    options: any[];
};

export default function ValidationSelect({
    containerClassName,
    error,
    ...props
}: TSelect) {
    return (
        <div className={containerClassName}>
            <Select {...props} />
            <span className="form-error">
                {error && (
                    <span className="error">{error}</span>
                )}
            </span>
        </div>
    );
}
